import classNames from 'classnames';
import { type Direction } from '@/shared/icons/flip-ui-kit/large/Arrow';

export type TabOption<T> = {
  Icon: (props: React.SVGProps<SVGSVGElement> & { direction?: Direction }) => React.JSX.Element;
  iconClassName?: string;
  iconDirection?: Direction;
  title: string;
  value: T;
  disabled?: boolean;
  indicatorCount?: number;
};

export default function PageTab<const T extends string>({
  selectedTab,
  onSelect,
  options,
  className,
}: {
  className?: string;
  selectedTab: T;
  onSelect: (tab: T) => void;
  options: TabOption<T>[];
}) {
  return (
    <div
      className={classNames(
        'flex w-full gap-4 overflow-x-auto overflow-y-hidden border-b border-cf-gray-3',
        className,
      )}
    >
      {options.map(
        ({ Icon, title, value, iconClassName, iconDirection, disabled, indicatorCount }) => (
          <button
            key={title}
            data-active={selectedTab === value}
            type="button"
            onClick={() => onSelect(value)}
            disabled={disabled}
            className={classNames(
              'group flex items-center py-3 pl-2 pr-3 font-aeonikMedium text-14 transition',
              'text-cf-light-2 data-active:!text-cf-white',
              'border-b border-transparent data-active:!border-cf-green-1',
              'enabled:hover:border-cf-gray-4 enabled:hover:text-cf-light-3',
            )}
          >
            <div className="flex items-center gap-x-1">
              <Icon className={iconClassName} direction={iconDirection} />
              {title}
              {indicatorCount && (
                <span className="inline-flex h-5 w-5 items-center justify-center rounded-[3px] border border-[rgba(70,218,147,.35)] bg-cf-green-4 text-12 text-cf-green-1">
                  {indicatorCount}
                </span>
              )}
            </div>
          </button>
        ),
      )}
    </div>
  );
}
